import { render, staticRenderFns } from "./DeliveryEvidence.vue?vue&type=template&id=2f574c9e&scoped=true&"
import script from "./DeliveryEvidence.vue?vue&type=script&lang=js&"
export * from "./DeliveryEvidence.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryEvidence.vue?vue&type=style&index=0&id=2f574c9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f574c9e",
  null
  
)

export default component.exports